module.exports = __webpack_public_path__ + "img/Attersee.1883e3a7.jpg";